// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OOjE9","header":"styles_header__SkUvg","action":"styles_action__Qc0ca"};